import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import GeneralInfo from "./components/GeneralInfo";
import News from "./components/News";
import Bonds from "./components/Bonds";
import Brands from "./components/Brands";
import Header from "../../constants/Header";
import Holdings from "./components/Holdings";
import DetailsTabs from "./components/DetailTab";
import ScrollCards from "./components/ScrollCards";
import {
  getGeneralInfo,
  getNews,
  getBonds,
  getBrands,
  getETFGeneralInfo,
  getHoldings,
} from "./network_requests";
import { CircularProgress } from "@material-ui/core";
import Competitors from "./components/Competators";
import { useSelector, useDispatch } from "react-redux";
import ETFGeneralInfo from "./components/ETFGeneralInfo";
import { getSearchResults } from "../search-results/network_requests";
import { useParams } from "react-router";
import { setStates } from "../../redux/states";
import { withNamespaces } from "react-i18next";
import Sources from "./components/Sources";

function SearchDetails({ t }) {
  const [cardWidth, setCardWidth] = useState(0);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const states = useSelector((state) => state.states.value);
  const [tabIndex, setTabIndex] = useState(states?.bonds ? 4 : 0);
  const [ISIN, setISIN] = useState(null);
  const [load, setLoad] = useState(false);
  const [generalInfo, setGeneralInfo] = useState(null);
  const [news, setNews] = useState(null);
  const [bonds, setBonds] = useState(null);
  const [brands, setBrands] = useState(null);
  const [holdings, setHoldings] = useState(null);
  const [sectors, setSectors] = useState([]);
  const [filters, setFilters] = useState({});
  const [Company, setCompany] = useState({});

  const dispatch = useDispatch();

  let { query, tabValue } = useParams();

  tabValue = parseInt(tabValue);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${query} - Stoqqy Search`;
    setStates({ ...states, tabValue: tabValue });
  }, [query]);

  useEffect(() => {
    if (
      states?.companies?.length === 0 ||
      !(states?.companies[0] ? states?.companies[0][0]?.Price : true)
    ) {
      (async () => {
        const data = await getSearchResults(query, {}, null, 1, tabValue, "");
        if (data !== "canceled" && data !== "error") {
          dispatch(
            setStates({
              ...states,
              companies: [[...(data?.companies ? data?.companies : [])]],
              tabValue: tabValue,
            })
          );
        }

        const data1 = await getSearchResults(
          query,
          {},
          null,
          1,
          tabValue !== 2 ? 2 : 1,
          ""
        );

        const data2 = await getSearchResults(
          query,
          {},
          data?.Session_Object,
          1,
          tabValue,
          ""
        );

        dispatch(
          setStates({
            ...states,
            companies: [[...(data2?.companies ? data2?.companies : [])]],
            countries: data2?.Country,
            continents: data2?.Continent,
            numberOfStock: data2?.Number_of_Stock,
            numberOfBond: data2?.Number_of_Bonds,
            numberOfETF: data1?.Number_of_Etfs,
            Sectors: data?.Sector ? data?.Sector : [],
            bondCompanies: data?.Number_of_Bonds_companies,
            ISIN: data2?.ISIN,
            tabValue: tabValue,
          })
        );
      })();
    }
  }, []);

  useEffect(() => {
    if (ISIN) {
      (async () => {
        setLoad(true);
        if (generalInfo) {
          setTabIndex(0);
        }
        setGeneralInfo(null);
        const generalInfo_ =
          tabValue !== 2
            ? await getGeneralInfo(ISIN)
            : await getETFGeneralInfo(ISIN);

        setGeneralInfo(generalInfo_);
        setLoad(false);
        if (tabValue !== 2) {
          const news_ = await getNews(ISIN);
          setNews(news_?.articles);
          const bonds_ = await getBonds(ISIN);
          setBonds(bonds_);
          const brands_ = await getBrands(ISIN);
          setBrands(brands_?.Brands);
        } else {
          const holdings_ = await getHoldings(ISIN);
          setHoldings(holdings_);
        }
      })();
    }
  }, [ISIN]);

  const innerWidth = useSelector((state) => state.innerWidth.value);

  return (
    <div
      style={{
        maxWidth: innerWidth,
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          position: isDesktopOrLaptop ? "absolute" : "",
          width: "100%",
          left: 0,
          top: 0,
          right: 0,
        }}
      >
        <Header t={t} />
      </div>
      {states.companies?.length > 0 ? (
        <div
          style={{
            minHeight: "100vh",
            marginTop: isDesktopOrLaptop ? "151px" : 0,
          }}
        >
          <ScrollCards
            setCardWidth={setCardWidth}
            setISIN={setISIN}
            ISIN={ISIN}
            setCompany={setCompany}
            Company={Company}
            t={t}
            tabValue={tabValue}
          />
          <Grid
            container
            style={{
              marginBottom: isDesktopOrLaptop ? "0px" : "21px",
              backgroundColor: "#f8f8f8",
              marginTop: isDesktopOrLaptop ? "40px" : "15px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              position: isDesktopOrLaptop ? "absolute" : "",
              width: "100%",
              left: 0,
            }}
          >
            <Grid
              item
              style={{
                minWidth: isDesktopOrLaptop ? "757px" : "auto",
              }}
            >
              <DetailsTabs
                tabValue={tabIndex}
                setTabValue={setTabIndex}
                ISIN={ISIN}
                t={t}
              />
            </Grid>
          </Grid>
          {load ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "50vh",
              }}
            >
              <CircularProgress style={{ color: "#808080" }} />
            </div>
          ) : null}
          <div
            style={{
              marginTop: isDesktopOrLaptop ? "132px" : 0,
            }}
          >
            {!load ? (
              tabIndex === 0 ? (
                tabValue === 2 ? (
                  <ETFGeneralInfo data={generalInfo} ISIN={ISIN} t={t} />
                ) : (
                  <GeneralInfo
                    data={generalInfo}
                    ISIN={ISIN}
                    Company={Company}
                    t={t}
                  />
                )
              ) : tabIndex === 1 ? (
                <News data={news} cardWidth={cardWidth} />
              ) : tabIndex === 2 ? (
                <Competitors
                  filters={filters}
                  setFilters={setFilters}
                  sectors={sectors}
                  setSectors={setSectors}
                  ISIN={ISIN}
                  setLoad={setLoad}
                  t={t}
                />
              ) : tabIndex === 3 ? (
                <Brands data={brands} cardWidth={cardWidth} />
              ) : tabIndex === 4 ? (
                <Bonds data={bonds} t={t} />
              ) : tabIndex === 5 ? (
                <Holdings values={holdings} t={t} />
              ) : tabIndex === 6 ? (
                <Sources ISIN={ISIN} />
              ) : null
            ) : null}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: isDesktopOrLaptop ? "25vh" : "5vh",
            minHeight: "100vh",
          }}
        >
          <CircularProgress style={{ color: "#808080" }} />
        </div>
      )}
    </div>
  );
}

export default withNamespaces()(SearchDetails);
